<template>
    <button
        @click="$emit('click')"
        :type="type"
        :class="{
            'opacity-25': processing,
            'bg-purple-600 active:bg-purple-600 hover:bg-purple-700 focus:shadow-outline-purple': color === 'purple',
            'bg-green-600 active:bg-green-600 hover:bg-green-500 focus:shadow-outline-green': color === 'green',
            'bg-red-600 active:bg-red-600 hover:bg-red-700 focus:shadow-outline-red': color === 'red',
            'bg-gray-600 active:bg-gray-600 hover:bg-gray-700 focus:shadow-outline-gray': color === 'gray'
        }"
        :disabled="processing"
        class="px-3 py-2 md:px-4 md:py-2 font-medium uppercase leading-5 text-white rounded border border-transparent focus:outline-none whitespace-no-wrap focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">
        <slot />
    </button>
</template>

<script>
export default {
    name: "Btn",
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        processing: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'purple'
        }
    }
}
</script>

<style scoped>

</style>
